<template>
	<div>
		<header>
			<img :src="lightboxHeaderImage">
		</header>

		<red-title>Enter to win a holiday in Japan for two!</red-title>

		<form @submit.prevent="submit" class="lightbox-form">
			<div class="form-control">
				<label for="f_name">First Name</label>
				<input type="text" name="f_name" id="f_name" v-validate="'required'" class="submit-me" @click="$root.dispatchEvent('formField', {field: 'f_name'});">
			</div>

			<div class="form-control">
				<label for="l_name">Last Name</label>
				<input type="text" name="l_name" id="l_name" v-validate="'required'" class="submit-me" @click="$root.dispatchEvent('formField', {field: 'l_name'});">
			</div>

			<div class="form-control">
				<label for="email">Email Address</label>
				<input type="email" name="email" id="email" v-validate="'required|email'" class="submit-me" @click="$root.dispatchEvent('formField', {field: 'email'});">
			</div>

			<div class="form-control">
				<label for="postcode">Postcode</label>
				<input type="number" name="postcode" id="postcode" v-validate="'required|digits:4'" class="submit-me" @click="$root.dispatchEvent('formField', {field: 'postcode'});">
			</div>

			<label for="terms" :class="{ 'form-checkbox': true, 'invalid': errors.has('terms') }">
				<input type="checkbox" name="terms" id="terms" v-validate="'required'" class="submit-me" @click="$root.dispatchEvent('formField', {field: 'terms'});"><span></span> <em>I agree to the <a href="https://www.jnto.org.au/app/uploads/2018/02/mfmm-tcs.pdf" target="_blank">Terms &amp; Conditions</a> and <a href="https://www.jnto.org.au/privacy-policy/" target="_blank">Privacy Policy</a></em>
			</label>

			<label for="opt-in" :class="{ 'form-checkbox': true }">
				<input type="checkbox" name="opt-in" id="opt-in" class="submit-me" @click="$root.dispatchEvent('formField', {field: 'opt-in'});"><span></span> <em>Yes, I’d like to subscribe to the Intrepid Travel newsletter to receive updates about travel news, deals and offers.</em>
			</label>

			<input type="hidden" name="campaign" :value="campaignId" class="submit-me">

			<red-button @click.native="submit" :class="{sending: isFormSaving}">
				<span v-if="isFormSaving">Saving...</span>
				<span v-else>Submit</span>
			</red-button>

			<p v-if="formError" v-html="formError" class="error"></p>
		</form>
	</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import * as constants from '../constants';
import * as h from '../helpers';
import RedTitle from './RedTitle';
import RedButton from './RedButton';
import TheLightboxDeal from './TheLightboxDeal';

Vue.use(VeeValidate, {
	'classes': true,
	'aria': false,
});

export default {
	components: { RedButton, RedTitle, TheLightboxDeal },
	data () {
		return {
			isFormSaving: false,
			formError: '',
		};
	},
	computed: {
		lightboxHeaderImage: function () { return require(`../assets/header-lightbox-${this.$root.activeMoment}.jpg`); },
		campaignId: () => constants.CAMPAIGN_ID,
	},
	methods: {
		async submit (e) {
			e.preventDefault();
			if (this.isFormSaving) {
				return;
			}

			let formData = {
				utm_source: this.getUtmField('utm_source'),
				utm_campaign: this.getUtmField('utm_campaign'),
				utm_medium: this.getUtmField('utm_medium'),
				entries: 1,
			};

			[].slice.call(h.$$('input.submit-me')).forEach(el => {
				if (el.getAttribute('type') === 'checkbox') {
					formData[el.name] = el.checked;
				} else {
					formData[el.name] = el.value;
				}
			});

			const result = await this.$validator.validateAll();
			if (result) {
				this.isFormSaving = true;
				this.formError = '';

				axios.post(`${constants.API_URL}/save/`, formData)
				.then((response) => {
					if (response.data.status !== 'ok') {
						throw Error('Server responded with error.');
					}
					localStorage.setItem('submitted', response.data.id);
					localStorage.setItem('entries', 1);
					this.$root.dispatchEvent('formSubmit');
					this.$emit('submitted');
					// All good
				})
				.catch((error) => {
					let errorMessage = '';
					if (error.response) {
						errorMessage = 'Wrong server response.';
					} else if (error.request) {
						errorMessage = 'No server response.';
					} else {
						errorMessage = error.message;
					}
					this.isFormSaving = false;
					this.formError = `Sorry, we could not save your information. Something went wrong.<br>${errorMessage}`;
				});
			}
			return false;
		},

		/**
		 * Returns the value of UTM code
		 */
		getUtmField (name, def = '') {
			try {
				const field = location.search
							.split('?')[1]
							.split('&')
							.map(el => el.split('='))
							.filter(el => el[0] === name)
							.map(el => el[1])[0];
				return field === undefined ? def : field;
			} catch (error) {
				return def;
			}
		},
	},
};
</script>

<style lang="less" scoped>
	@import (reference) '../assets/_mixins.less';

	// Form
	form { display: flex; flex-direction: column; max-width: 300px; margin: 0 auto 2em;
		.red-button--right {
			&.sending { background-color: #ccc;
				@keyframes loading {
					0% { transform: rotate(0deg); }
					100% { transform: rotate(360deg); }
				}
				span { position: relative; }
				span:before { .top-left(-2px,-24px); content: ""; display: block; .size(16px); border-radius: 50%; border: 1px solid white; border-top-color: #e60017; animation: 1s loading infinite; }
			}
		}
	}
	.form-control { display: flex; align-items: center; margin-bottom: 1em;
		label { width: 40%;  }
		input { width: 55%; flex: 1 1 auto; padding: 5px 1ex; border-radius: 0; -webkit-appearance: none; background-color: white; }
	}
	.form-checkbox { display: flex; margin-bottom: 1em;
		input { display: none; }
		input + span { display: block; .size(26px); flex: 1 0 auto; margin-right: 1em; border: 1px solid black; }
		input:checked + span { .bgc(#e60017); }
		em { font-style: normal; text-transform: none; }
		a { color: #e60017; text-decoration: underline; }
		&.invalid input + span { border-color: #e60017; }
	}
	label { font-size: 14px; text-transform: uppercase; font-weight: 600; }
	input { border: 1px solid black;
		&.invalid { border-color: #e60017; }
	}
	.error { margin-top: 2em; color: #e60017; text-align: center; font-size: 10px; }
</style>



// WEBPACK FOOTER //
// src/components/TheLightboxForm.vue